"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.setOrderNumberToMetaOptions = exports.mapStateToProps = void 0;
exports.addMetaOption = addMetaOption;
exports.addMetaSubOption = addMetaSubOption;
exports.setRadioValue = setRadioValue;
var React = require("react");
var react_redux_1 = require("react-redux");
var react_select_1 = require("react-select");
var uuid_1 = require("uuid");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var projectWizard = require("@caddigital/sok-reducers/lib/actions/project/wizard");
var Icon_1 = require("components/Icon");
require("./style.scss");
var sok_types_1 = require("@caddigital/sok-types");
var sort = function (a, b) {
    var aId = a.order ? a.order : -1;
    var bId = b.order ? b.order : -1;
    return aId - bId;
};
var mapStateToProps = function (state) {
    var dropDownValues = state.project.wizard.metaModal.values.options || [];
    var values = dropDownValues.sort(sort).map(function (f, i) { return (__assign(__assign({}, f), { order: i, options: f.options ? f.options.sort(sort) : undefined })); });
    var orders = Object.values(state.project.wizard.step4.metaMap).map(function (x) { return x.order; });
    var nextOrderNumber = Math.max.apply(Math, orders) + 1;
    return {
        options: dropDownValues,
        values: values,
        metaModal: state.project.wizard.metaModal,
        wizard: state.project.wizard,
        nextOrderNumber: nextOrderNumber
    };
};
exports.mapStateToProps = mapStateToProps;
var setOrderNumberToMetaOptions = function (options) {
    return options.map(function (o, k) { return (__assign(__assign({}, o), { order: o.order ? o.order : k })); });
};
exports.setOrderNumberToMetaOptions = setOrderNumberToMetaOptions;
var mapDispatchToProps = function (dispatch) { return ({
    updateField: function (field) { return function (value) {
        return dispatch(projectWizard.setMetaField(field, value));
    }; },
    setSelectedValue: function (field) {
        return function (_a) {
            var value = _a.target.value;
            return dispatch(projectWizard.setSelectedValue(value));
        };
    },
    updateType: function (selectedOption) {
        if (selectedOption.value === 'checkbox') {
            dispatch(projectWizard.setMetaField('required', false));
        }
        dispatch(projectWizard.setMetaField('type', selectedOption.value));
    },
    addDropdownValue: function (x, order, parent) {
        dispatch(projectWizard.setMetaOptionsValue({ name: x, value: x, order: order }, parent));
    },
    updateDropdownValue: function (x, order, parent) {
        dispatch(projectWizard.updateMetaOptionsValue({ name: x, value: x, order: order }, parent));
    },
    removeDropdownValue: function (props) {
        return function (x, parent) {
            dispatch(projectWizard.deleteMetaOptionsValue(x, parent));
        };
    },
    updateRequiredCheckBox: function (_a) {
        var checked = _a.target.checked;
        return dispatch(projectWizard.setMetaField('required', checked));
    },
    toggleModal: function () { return dispatch(projectWizard.closeMetaModal()); },
    addMeta: function (isOpen, schemaId, meta, order) {
        return function (props) {
            var identifier = isOpen === 'EDIT' ? meta.identifier : (0, uuid_1.v4)();
            var options = meta.options
                ? (0, exports.setOrderNumberToMetaOptions)(meta.options)
                : [];
            var params = {
                identifier: identifier,
                id: meta.id,
                name: meta.name,
                submeta: isOpen === 'EDIT'
                    ? meta.submeta
                    : __assign(__assign({}, meta.submeta), { identifier: (0, uuid_1.v4)() }),
                type: meta.type,
                bitField: sok_types_1.CustomMeta.FILES_LIST,
                options: options,
                required: meta.required || false,
                editable: meta.editable || false,
                hideOnFileList: meta.hideOnFileList || false,
                mandatory: meta.mandatory || false,
                order: isOpen === 'EDIT' ? meta.order : order
            };
            if (params.mandatory) {
                params.bitField |= sok_types_1.CustomMeta.MANDATORY;
            }
            if (params.required) {
                params.bitField |= sok_types_1.CustomMeta.REQUIRED;
            }
            if (params.editable) {
                params.bitField |= sok_types_1.CustomMeta.EDITABLE;
            }
            if (params.hideOnFileList) {
                params.bitField |= sok_types_1.CustomMeta.HIDE_ON_FILES_LIST;
            }
            dispatch(projectWizard.addMetaElement(schemaId, [params]));
        };
    },
    updateRadio: function (f, x) { return function () {
        if (f === 'editable') {
            dispatch(projectWizard.setMetaField('required', false));
        }
        dispatch(projectWizard.setMetaField(f, x));
    }; }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
//#endregion
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('optionInputValue', 'setOptionInputValue', ''), (0, recompose_1.withState)('subOptionInputValue', 'setSubOptionInputValue', {}), (0, recompose_1.withState)('subOptions', 'setSubOptions', {}), (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), recompose_1.pure);
function addMetaOption(props) {
    if (props.optionInputValue.trim().length === 0) {
        return;
    }
    if (props.options.findIndex(function (o) { return o.name === props.optionInputValue; }) === -1) {
        var o = props.metaModal.values.options &&
            props.metaModal.values.options.length > 0
            ? Math.max.apply(Math, props.metaModal.values.options.map(function (o) {
                return o && o.order ? o.order : 0;
            })) + 1
            : 0;
        props.addDropdownValue(props.optionInputValue, o);
        props.setOptionInputValue('');
    }
}
function addMetaSubOption(value, order, index, parent, props) {
    if (!value || value === '') {
        return;
    }
    var optionInput = __assign({}, props.subOptionInputValue);
    optionInput[index] = '';
    props.addDropdownValue(value, order, parent);
    props.setSubOptionInputValue(optionInput);
}
function setRadioValue(metaField, selected, props) {
    return props.updateRadio(metaField, selected);
}
function getError(props, field) {
    if (props.metaModal.error && props.metaModal.error[field]) {
        return (React.createElement("span", { className: 'validation-error' }, props.metaModal.error[field]));
    }
    return undefined;
}
var MetaName = (0, recompose_1.compose)((0, recompose_1.withState)('value', 'setValue', null), recompose_1.pure)(function (props) {
    var value = '';
    if (props.value === null) {
        value = props.metaModal.values.name;
    }
    else {
        value = props.value;
    }
    return (React.createElement(sok_ui_1.TextInput, { id: 'name', className: 'white meta-modal-input', value: value, onChange: function (e) { return props.setValue(e.target.value); }, onBlur: function () {
            if (value === props.metaModal.values.name) {
                return;
            }
            props.updateField('name')(value);
            props.setValue(null);
        } }));
});
var MetaSubName = (0, recompose_1.compose)((0, recompose_1.withState)('value', 'setValue', null), recompose_1.pure)(function (props) {
    var value = '';
    if (props.value === null) {
        value = props.metaModal.values.submeta
            ? props.metaModal.values.submeta.name
            : '';
    }
    else {
        value = props.value;
    }
    return (React.createElement(sok_ui_1.TextInput, { id: 'name', className: 'white meta-modal-input', value: value, onChange: function (e) { return props.setValue(e.target.value); }, onBlur: function () {
            props.updateField('submeta.name')(value);
            props.setValue(null);
        } }));
});
exports.default = enhance(function (props) { return (React.createElement(sok_ui_1.Modal, { isOpen: props.metaModal.isOpen === 'EDIT' || props.metaModal.isOpen === 'CREATE', className: 'project-meta-modal' },
    React.createElement(sok_ui_1.Header, { onClose: props.toggleModal }, props.metaModal.isOpen === 'EDIT'
        ? (0, translation_1.getLocalization)('admin/projectsTab/editProject/modals/metadata/edit')
        : (0, translation_1.getLocalization)('admin/projectsTab/editProject/modals/metadata/new')),
    React.createElement(sok_ui_1.Container, null,
        React.createElement(sok_ui_1.RequestStatusBox, { key: 'request', status: props.metaModal.isSaving, statusList: ['STANDBY', 'SAVING', 'SAVED', 'FAILED'] },
            (0, translation_1.getLocalization)('admin/projectsTab/editProject/modals/metadata/saving'),
            (0, translation_1.getLocalization)('admin/projectsTab/editProject/modals/metadata/saved'),
            (0, translation_1.getLocalization)('admin/projectsTab/editProject/modals/metadata/failed')),
        props.metaModal.isOpen !== 'NONE' && (React.createElement("div", { className: 'meta-modal' },
            React.createElement("div", { className: 'meta-modal-content' },
                React.createElement(sok_ui_1.Grid.Row, null,
                    React.createElement(sok_ui_1.Grid.Column, null,
                        React.createElement("label", null, (0, translation_1.getLocalization)('admin/projectsTab/editProject/modals/metadata/selectType')),
                        React.createElement(react_select_1.default, { classNamePrefix: "react-select", placeholder: (0, translation_1.getLocalization)('admin/projectsTab/editProject/modals/metadata/selectType'), className: 'meta-modal-input', menuPlacement: 'auto', isDisabled: props.metaModal.values.identifier.includes('color-meta') ||
                                props.metaModal.values.mandatory, value: props.wizard.types.filter(function (x) {
                                return props.metaModal.isOpen !== 'NONE' &&
                                    props.metaModal.values.type === x.value;
                            }), getOptionValue: function (opt) { return opt.value; }, getOptionLabel: function (opt) { return opt.name; }, onChange: props.updateType, options: props.wizard.types, isClearable: false }))),
                React.createElement(sok_ui_1.Grid.Row, { className: props.metaModal.values.type === 'dependant-select'
                        ? 'dependant-select'
                        : '' },
                    React.createElement(sok_ui_1.Grid.Column, { medium: props.metaModal.values.type === 'dependant-select' ? 6 : 12 },
                        React.createElement("label", { htmlFor: 'name' }, (0, translation_1.getLocalization)('admin/projectsTab/editProject/modals/metadata/name')),
                        React.createElement(MetaName, __assign({}, props)),
                        getError(props, 'name')),
                    props.metaModal.values.type === 'dependant-select' && (React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                        React.createElement("label", { htmlFor: 'name' }, (0, translation_1.getLocalization)('admin/projectsTab/editProject/modals/metadata/subName')),
                        React.createElement(MetaSubName, __assign({}, props)),
                        getError(props, 'name')))),
                React.createElement(sok_ui_1.Grid.Row, null,
                    React.createElement(sok_ui_1.Grid.Column, null,
                        React.createElement("div", null,
                            React.createElement(sok_ui_1.Input, { type: 'checkbox', name: 'box', label: (0, translation_1.getLocalization)('admin/projectsTab/editProject/modals/metadata/mandatory'), disabled: props.metaModal.values.type === 'checkbox' ||
                                    !props.metaModal.values.editable, value: props.metaModal.values.required, onChange: props.updateRequiredCheckBox })))),
                React.createElement(sok_ui_1.Grid.Row, null,
                    props.metaModal.values.type === 'checkbox' && (React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                        React.createElement("form", { onSubmit: function (e) { return (e.preventDefault(), addMetaOption(props)); } },
                            React.createElement("div", null,
                                React.createElement("label", { htmlFor: 'selected' },
                                    React.createElement(Icon_1.Icon, { className: 'fa-folder' }),
                                    ' ',
                                    (0, translation_1.getLocalization)('admin/projectsTab/editProject/modals/metadata/show')),
                                React.createElement(sok_ui_1.Input, { type: 'radio', name: 'selected', label: (0, translation_1.getLocalization)('admin/projectsTab/editProject/modals/metadata/show'), value: !props.metaModal.values.hideOnFileList, onClick: setRadioValue('hideOnFileList', false, props) }),
                                React.createElement(sok_ui_1.Input, { type: 'radio', name: 'selected', label: (0, translation_1.getLocalization)('admin/projectsTab/editProject/modals/metadata/hide'), value: props.metaModal.values.hideOnFileList, onClick: setRadioValue('hideOnFileList', true, props) }))))),
                    React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                        React.createElement("label", { htmlFor: 'locked' },
                            React.createElement(Icon_1.Icon, { className: 'fa-folder' }),
                            ' ',
                            (0, translation_1.getLocalization)('admin/projectsTab/editProject/modals/metadata/lock/label')),
                        React.createElement(sok_ui_1.Input, { type: 'radio', name: 'locked', disabled: props.metaModal.values.identifier.includes('color-meta') ||
                                props.metaModal.values.mandatory, label: (0, translation_1.getLocalization)('admin/projectsTab/editProject/modals/metadata/lock/on'), value: !props.metaModal.values.editable, onClick: setRadioValue('editable', false, props) }),
                        React.createElement(sok_ui_1.Input, { type: 'radio', name: 'locked', disabled: props.metaModal.values.identifier.includes('color-meta') ||
                                props.metaModal.values.mandatory, label: (0, translation_1.getLocalization)('admin/projectsTab/editProject/modals/metadata/lock/off'), value: props.metaModal.values.editable, onClick: setRadioValue('editable', true, props) }))),
                props.metaModal.values.type === 'select' && (React.createElement("div", null,
                    React.createElement("form", { onSubmit: function (e) { return (e.preventDefault(), addMetaOption(props)); } },
                        React.createElement("div", { className: 'metadata-dropdown' },
                            React.createElement(sok_ui_1.Grid.Row, null,
                                React.createElement(sok_ui_1.Grid.Column, { className: 'dropdown-value' },
                                    React.createElement(sok_ui_1.TextInput, { id: 'dropDownValueInput', value: props.optionInputValue, className: 'white meta-modal-input', onChange: function (e) {
                                            return props.setOptionInputValue(e.target.value);
                                        } }),
                                    React.createElement("span", { className: 'modal-input-span' },
                                        React.createElement(Icon_1.Icon, { className: 'fa-plus-circle modal-input-icon', onClick: function () { return addMetaOption(props); } }),
                                        React.createElement("input", { className: 'modal-input', type: 'submit', onClick: function () { return addMetaOption(props); } })))),
                            React.createElement(sok_ui_1.Grid.Row, null,
                                React.createElement(sok_ui_1.Grid.Column, null,
                                    props.values.map(function (v) { return (React.createElement("div", { className: 'metadata-row' },
                                        React.createElement("span", null, v.name),
                                        React.createElement(Icon_1.Icon, { className: 'fa-chevron-circle-down modal-input-icon', onClick: function () {
                                                return props.updateDropdownValue(v.value, v.order + 1);
                                            } }),
                                        React.createElement(Icon_1.Icon, { className: 'fa-chevron-circle-up modal-input-icon', onClick: function () {
                                                return props.updateDropdownValue(v.value, v.order - 1);
                                            } }),
                                        React.createElement(Icon_1.Icon, { className: 'fa-times-circle modal-input-icon', onClick: function () {
                                                return props.removeDropdownValue(props)(props.values.filter(function (f) { return f.order !== v.order; }));
                                            } }))); }),
                                    getError(props, 'options'))))))),
                props.metaModal.values.type === 'dependant-select' && (React.createElement("div", null,
                    React.createElement("form", { onSubmit: function (e) { return (e.preventDefault(), addMetaOption(props)); } },
                        React.createElement("div", { className: 'metadata-dropdown' },
                            React.createElement(sok_ui_1.Grid.Row, null,
                                React.createElement(sok_ui_1.Grid.Column, { className: 'dropdown-value' },
                                    React.createElement(sok_ui_1.TextInput, { id: 'dropDownValueInput', value: props.optionInputValue, className: 'white meta-modal-input', onChange: function (e) {
                                            return props.setOptionInputValue(e.target.value);
                                        } }),
                                    React.createElement("span", { className: 'modal-input-span' },
                                        React.createElement(Icon_1.Icon, { className: 'fa-plus-circle modal-input-icon', onClick: function () { return addMetaOption(props); } }),
                                        React.createElement("input", { className: 'modal-input', type: 'submit', onClick: function () { return addMetaOption(props); } })),
                                    getError(props, 'options'))),
                            props.values.map(function (v) {
                                var i = v.value;
                                return (React.createElement(sok_ui_1.Grid.Row, { className: 'metadata-container' },
                                    React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                                        React.createElement("div", { className: 'metadata-row' },
                                            React.createElement("span", null, v.name),
                                            React.createElement(Icon_1.Icon, { className: 'fa-chevron-circle-down modal-input-icon', onClick: function () {
                                                    return props.updateDropdownValue(v.value, v.order + 1);
                                                } }),
                                            React.createElement(Icon_1.Icon, { className: 'fa-chevron-circle-up modal-input-icon', onClick: function () {
                                                    return props.updateDropdownValue(v.value, v.order - 1);
                                                } }),
                                            React.createElement(Icon_1.Icon, { className: 'fa-times-circle modal-input-icon', onClick: function () {
                                                    props.removeDropdownValue(props)(props.values.filter(function (f) { return f.order !== v.order; }));
                                                } }))),
                                    React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                                        React.createElement("div", { className: 'submetadata' },
                                            React.createElement("form", { onSubmit: function (e) { return (e.preventDefault(),
                                                    addMetaSubOption(props.subOptionInputValue[i], v.options ? v.options.length : 0, i, v, props)); } },
                                                React.createElement("div", { className: 'metadata-dropdown' },
                                                    React.createElement(sok_ui_1.Grid.Row, null,
                                                        React.createElement(sok_ui_1.Grid.Column, { className: 'dropdown-value' },
                                                            React.createElement(sok_ui_1.TextInput, { id: 'dropDownValueInput', value: props.subOptionInputValue[i], className: 'white meta-modal-input', onChange: function (e) {
                                                                    var option = __assign({}, props.subOptionInputValue);
                                                                    option[i] = e.target.value;
                                                                    props.setSubOptionInputValue(option);
                                                                } }),
                                                            React.createElement("span", { className: 'modal-input-span' },
                                                                React.createElement(Icon_1.Icon, { className: 'fa-plus-circle modal-input-icon', onClick: function () {
                                                                        return addMetaSubOption(props.subOptionInputValue[i], v.options ? v.options.length : 0, i, v, props);
                                                                    } }),
                                                                React.createElement("input", { className: 'modal-input', type: 'submit', onClick: function () {
                                                                        return addMetaSubOption(props.subOptionInputValue[i], v.options ? v.options.length : 0, i, v, props);
                                                                    } })))),
                                                    React.createElement(sok_ui_1.Grid.Row, null,
                                                        React.createElement(sok_ui_1.Grid.Column, null,
                                                            Array.isArray(v.options) &&
                                                                v.options.map(function (x) { return (React.createElement("div", { className: 'metadata-row submetadata-row' },
                                                                    React.createElement("span", null, x.name),
                                                                    React.createElement(Icon_1.Icon, { className: 'fa-chevron-circle-down modal-input-icon', onClick: function () {
                                                                            return props.updateDropdownValue(x.value, x.order + 1, v);
                                                                        } }),
                                                                    React.createElement(Icon_1.Icon, { className: 'fa-chevron-circle-up modal-input-icon', onClick: function () {
                                                                            return props.updateDropdownValue(x.value, x.order - 1, v);
                                                                        } }),
                                                                    React.createElement(Icon_1.Icon, { className: 'fa-times-circle modal-input-icon', onClick: function () {
                                                                            props.removeDropdownValue(props)([x], v);
                                                                        } }))); }),
                                                            getError(props, v.value)))))))));
                            }))))))))),
    React.createElement(sok_ui_1.Footer, null,
        React.createElement(sok_ui_1.Button, { color: 'base-green', text: (0, translation_1.getLocalization)('userfront/button/save'), onClick: function () {
                props.metaModal.isOpen !== 'NONE' &&
                    props.schemaId !== null &&
                    props.addMeta(props.metaModal.isOpen, props.schemaId, props.metaModal.values, props.nextOrderNumber)(props);
            } }),
        React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('userfront/button/cancel'), color: 'dark-gray', onClick: props.toggleModal })))); });
